import {
    Component,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    output,
    input,
    computed,
} from '@angular/core'
import { TbCounterComponent } from '@components-library/common/tb-counter/tb-counter.component'
import { TruncateIconsDirective } from '@components-library/directives/truncate-icons.directive'
import { ModalManagerService } from '@components-library/tb-modal-manager/modal-manager.service'
import { Workspace, Schema, isWorkspaceGlobal } from '@core/models'
import { schemaIconByName } from '@shared/models/icons'
import {
    RecordSettingsContentComponent,
    RecordSettingsData,
} from './record-settings-content/record-settings-content.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { EnvDirective } from '@shared/env.directive'
import { NgTemplateOutlet } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'
import { partition } from 'lodash-es'

@Component({
    selector: 'app-add-record-settings-section',
    templateUrl: './add-record-settings-section.component.html',
    styleUrl: './add-record-settings-section.component.sass',
    imports: [
        TranslocoModule,
        NgTemplateOutlet,
        EnvDirective,
        TbIconComponent,
        TruncateIconsDirective,
        TbCounterComponent,
    ],
})
export class AddRecordSettingsSectionComponent implements OnInit, OnChanges {
    protected modalManagerService = inject(ModalManagerService)

    protected readonly schemaIconByName = schemaIconByName

    workspaces = input.required<Workspace[]>()
    schemas = input.required<Schema[]>()
    pickedWorkspaces = input.required<Workspace[]>()
    selectedSchemaGuid = input.required<string>()

    saveSettings = output<{
        workspaceGuids: string[]
        schemaGuid: string
    }>()

    selectedSchema = computed(() => {
        return this.schemas().find((schema) => schema.guid === this.selectedSchemaGuid())!
    })

    globalWorkspace!: Workspace
    workspacesWithoutGlobal!: Workspace[]

    ngOnInit() {
        this.setGlobalAndWithoutGlobal()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.pickedWorkspaces && !changes.pickedWorkspaces.isFirstChange()) {
            this.setGlobalAndWithoutGlobal()
        }
    }

    openDialog() {
        const dialogRef = this.modalManagerService.openDialog<
            RecordSettingsContentComponent,
            RecordSettingsData,
            { workspaceGuids: string[]; schemaGuid: string }
        >({
            component: RecordSettingsContentComponent,
            data: {
                workspaces: this.workspaces(),
                schemas: this.schemas(),
                selectedWorkspacesGuid: this.pickedWorkspaces().map((workspace) => workspace.guid),
                selectedSchemaGuid: this.selectedSchemaGuid(),
            },
        })

        dialogRef.subscribe((data) => {
            if (data) {
                this.saveSettings.emit({
                    workspaceGuids: data.workspaceGuids,
                    schemaGuid: data.schemaGuid,
                })
            }
        })
    }

    private setGlobalAndWithoutGlobal() {
        if (this.pickedWorkspaces().length === 1) return

        const [globalWorkspaces, workspacesWithoutGlobal] = partition(
            this.pickedWorkspaces(),
            isWorkspaceGlobal,
        )

        this.globalWorkspace = globalWorkspaces[0]
        this.workspacesWithoutGlobal = workspacesWithoutGlobal
    }
}
